import { useAuth } from 'components/AuthProvider'
import { useMutateActivateVault } from 'hooks/useInventory'
import { useEffect, useState } from 'react'
import { generateUsername } from 'utils/util'

interface VaultishThing {
  name?: string | null
  id?: string | null
}

export default function useVault() {
  const { user, setLoading, refreshCurrentUser } = useAuth()

  const [activatedVault, setActivatedVault] = useState<VaultishThing>(
    user && user?.activatedVault?.name
      ? {
          name: user?.activatedVault?.name,
          id: user?.activatedVault?.id
        }
      : {
          name: generateUsername(user),
          id: user?.activatedVault?.id
        }
  )

  const activateVaultMutation = useMutateActivateVault()

  const handleActiveVault = async (id: number | null | string) => {
    setLoading(true)
    try {
      const vaultId = Number(id)
      const vault = await activateVaultMutation.mutateAsync(vaultId)

      if (vault) {
        setActivatedVault(
          vault?.name
            ? {
                name: vault?.name,
                id: String(vault?.id)
              }
            : {
                name: generateUsername(user),
                id: String(vault?.id)
              }
        )
        await refreshCurrentUser()
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    setActivatedVault(
      user?.activatedVault && user?.activatedVault?.name
        ? {
            name: user?.activatedVault?.name,
            id: user.activatedVault?.id
          }
        : {
            name: generateUsername(user),
            id: user?.activatedVault?.id
          }
    )
  }, [user])

  return {
    loading: activateVaultMutation.isLoading,
    handleActiveVault,
    activatedVault,
    activatedVaultId: Number(activatedVault.id)
  }
}
